class Ganaly {
  /*
  埋点资源位曝光
  spm格式: 1.2bd3.3f23.80d7
  seq: null
  spm: 1.2bd3.3f23.80d7
   */
  GanaExposure (type, uri, index, spm, deliveryGcm) {
    var gcm = genGcm(type, uri, deliveryGcm)
    var obj = {
      gcm,
      spm
    }

    obj.spm = genSpm(spm, index)

    return obj
  }
  /*
  埋点资源位点击
  spm格式: 1.2bd3.3f23.80d7
   */
  GanaClick (type, uri, spm, index, deliveryGcm) {
    var gcm = genGcm(type, uri, deliveryGcm)
    var obj = {
      gcm
    }
    obj.spm = genSpm(spm, index)
    return JSON.stringify(obj)
  }

  GanaClickForAddCart (options) {
    let { type, uri } = options
    delete options.type
    delete options.uri
    let obj = {
      gcm: {
        type,
        uri
      },
      ...options
    }
    return JSON.stringify(obj)
  }

  genSpm (spm, index) {
    return genSpm(spm, index)
  }
}

function genGcm (type, uri, deliveryGcm) {
  let gcm
  if (typeof deliveryGcm == 'string') {
    gcm = deliveryGcm
  } else {
    if (Array.isArray(uri)) {
      gcm = uri.map(item => {
        return {
          type,
          uri: item
        }
      })
    } else {
      gcm = {
        type: type,
        uri: uri
      }
    }
  }
  return gcm
}

function genSpm (spm, index) {
  // console.log(spm,index)
  var tmp = spm.split('.') // 1.2bd3.3f23.80d7 统一传递4位spm,如果最后一位为${index+1}可传0
  if (tmp.length == 4 && typeof index == 'number') {
    tmp.pop() // 移除最后一位
    spm = tmp.join('.') + '.'
  }
  if ((index + '').includes('_')) {
    var arr = (index + '').split('_')
    arr.forEach((item, i) => {
      arr[i] = (+item + 1)
    })
    var str = arr.join('_')
    spm = spm + str
  } else if (typeof index == 'number') {
    spm = spm + (index + 1)
  }
  return spm
}

export default Ganaly
